export const confirmDeleteTeamMember = async (functionParameters={}) =>{

    let {firstName, lastName } = functionParameters;

    functionParameters.sideMenuItems = window.currentSideMenuItems;
    functionParameters.smetioAppUi = window.currentSmetioAppUi;

    const setTxtV2 = (await import(/* webpackPrefetch: true */ "../../../classes/universal_methods/setTxtV2.js")).setTxtV2;
    const getConfirmationSmartbox = (await import(/* webpackPrefetch: true */ "./../../get/getConfirmationSmartbox")).getConfirmationSmartbox;
    
    let deleteTeamMemberText = setTxtV2({ attributes: {}, txt:  "txt752", type: "html" });
    deleteTeamMemberText = deleteTeamMemberText.replace("[#teamMember]", `${firstName} ${lastName}`);
    deleteTeamMemberText = deleteTeamMemberText.replace("[#tagA1]", "<strong>");
    deleteTeamMemberText = deleteTeamMemberText.replace("[#tagA2]", "</strong>");
    


    let instructText1 =  setTxtV2({ attributes: {}, txt:  "txt755", type: "html" });
    instructText1 = instructText1.replace("[#actionToBePerformed]", deleteTeamMemberText);
    instructText1 = `<p class="smetio-h6-heading smetio-margin-bottom-40"> ${ instructText1 } </p> `;     

    const instructText2 = `<h6 class="smetio-h6-heading "> ${ setTxtV2({ attributes: {}, txt: "txt753", type: "html" }) } </h6> `;

    return getConfirmationSmartbox({
        informationTexts: [instructText1, instructText2],
        buttonText: "txt258",
        smartboxName: "confirmDeleteTeamMemberSmartbox",
        functionDetails: {
            functionPath: "apps/teamMembers/deleteTeamMember",
            functionParameters
        }
    });


    
};
